
(function () {
  'use strict';

  document.querySelectorAll('[data-z9-products-tabbed]').forEach(initSection);

  function initSection(section) {
    
    var tabs = section.querySelectorAll('[data-z9-tab]');
    var panels = section.querySelectorAll('[data-z9-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = this.dataset.z9Tab;
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        this.classList.add('is-active');
        var target = section.querySelector('[data-z9-panel="' + id + '"]');
        if (target) target.classList.add('is-active');
      });
    });

    
    section.querySelectorAll('.z9-pc__add-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var vid = btn.dataset.variantId;
        if (!vid || btn.disabled) return;
        btn.disabled = true;
        var origSvg = btn.innerHTML;
        var ss = btn.dataset.splitText || '';
        var props = ss ? { 'Split Shipping': ss } : null;

        addToCart(vid, props, function (ok) {
          if (ok) {
            btn.classList.add('z9-pc__add-btn--added');
            btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="18" height="18"><path d="M20 6L9 17l-5-5"/></svg>';
            setTimeout(function () {
              btn.classList.remove('z9-pc__add-btn--added');
              btn.innerHTML = origSvg;
              btn.disabled = false;
            }, 2000);
          } else {
            btn.disabled = false;
          }
        });
      });
    });
  }

  function addToCart(variantId, properties, cb) {
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { id: parseInt(variantId, 10), quantity: 1 };
    if (properties) body.properties = properties;

    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
      cartEl.setActiveElement(document.activeElement);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (response) {
        if (response.status) throw new Error();
        cb(true);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'z9-products-tabbed',
            productVariantId: variantId,
            cartData: response
          });
        }
        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(response);
          if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { cb(false); });
  }
})();
